import { Grid, TextField } from "@mui/material";
import CryptoJS from "crypto-js/";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { HeightAdjustedButton } from "../utils/StyledComponents";

const Login = () => {
  const initialState = {
    username: "",
    hashedPassword: "",
  };
  const [state, setState] = useState(initialState);
  const navigate = useNavigate();

  function onEnterPress(event) {
    if (event.key === "Enter") {
      onLogin();
    }
  }

  function onLogin() {
    console.log(state.username);
    console.log(state.hashedPassword);
    localStorage.setItem("username", state.username);
    localStorage.setItem("passwordHash", state.hashedPassword);
    navigate("/");
  }

  function onUsernameChange(event) {
    setState({ ...state, username: event.target.value });
  }

  function onPasswordChange(event) {
    const password = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(event.target.value));
    setState({ ...state, hashedPassword: password });
  }

  function renderLogin() {
    return (
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 4 }}>
          <TextField
            variant="outlined"
            label={"UserName"}
            value={state.username}
            name={"username"}
            onChange={onUsernameChange}
            onKeyDown={onEnterPress}
            fullWidth={true}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <TextField
            type="password"
            variant="outlined"
            label={"Password"}
            name={"password"}
            onChange={onPasswordChange}
            onKeyDown={onEnterPress}
            fullWidth={true}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <HeightAdjustedButton
            variant="contained"
            color="primary"
            onClick={onLogin}
            fullWidth={true}
            size="large"
            disableElevation
          >
            Login
          </HeightAdjustedButton>
        </Grid>
      </Grid>
    );
  }

  function render() {
    const username = localStorage.getItem("username");

    if (username !== null) {
      return <></>;
    }

    return renderLogin();
  }

  return render();
};

export default Login;
